// theme-sources/js/theme/components/cart-drawer.js

import { logger } from "../core/logger";

class CartDrawer extends HTMLElement {
  renderContents(parsedState) {
    const drawerInner = this.querySelector(".drawer__inner");
    if (drawerInner?.classList.contains("is-empty")) {
      drawerInner.classList.remove("is-empty");
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionHtml = parsedState.sections?.[section.id];
      if (!sectionHtml) {
        logger.warn("CartDrawer", "Section non trouvée", section.id);
        return;
      }

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) {
        logger.warn("CartDrawer", "Element cible non trouvé", section);
        return;
      }

      sectionElement.innerHTML = this.getSectionInnerHTML(
        sectionHtml,
        section.selector,
      );
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const el = doc.querySelector(selector);

    if (!el) {
      logger.warn("CartDrawer", "Selector non trouvé dans section HTML", {
        selector,
      });
      return "";
    }

    return el.innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: this.dataset.sectionId,
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}
